exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-28b3e73f],h3[data-v-28b3e73f]{margin:0}.hello[data-v-28b3e73f]{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;height:100%}.hello[data-v-28b3e73f],.module[data-v-28b3e73f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-box-align:center;align-items:center}.module[data-v-28b3e73f]{text-align:center;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center}h1[data-v-28b3e73f]{font-size:36px}h3[data-v-28b3e73f]{font-size:30px}.hello a[data-v-28b3e73f]{text-decoration:none;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28b3e73f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/Login.vue
// module id = sdlE
// module chunks = 1